// Comprehensive mock users data for local demo flows.

const ALL_PROJECTS = ['project-1', 'project-2', 'project-5'];

export const MOCK_USERS = [
  {
    id: '0',
    email: 'superadmin@agrilink.dev',
    firstName: 'Super',
    lastName: 'Admin',
    phone: '+39 320 100 0000',
    role: 'superadmin',
    farms: ALL_PROJECTS,
    isActive: true,
    emailVerified: true,
    lastLogin: new Date(Date.now() - 45 * 60000),
    createdAt: new Date('2022-11-01T09:00:00Z'),
  },
  {
    id: '1',
    email: 'admin@agrilink.dev',
    firstName: 'Admin',
    lastName: 'User',
    phone: '+39 321 123 4567',
    role: 'admin',
    farms: ALL_PROJECTS,
    isActive: true,
    emailVerified: true,
    lastLogin: new Date(Date.now() - 2 * 3600000),
    createdAt: new Date('2023-01-15T10:00:00Z'),
  },
  {
    id: '3',
    email: 'maria.viewer@agrilink.dev',
    firstName: 'Maria',
    lastName: 'Rossi',
    phone: '+39 456 789 0123',
    role: 'viewer',
    farms: ['project-1', 'project-5'],
    isActive: true,
    emailVerified: true,
    lastLogin: new Date(Date.now() - 60 * 60000),
    createdAt: new Date('2023-05-10T08:30:00Z'),
  },
  {
    id: '4',
    email: 'marco.verde@agrilink.dev',
    firstName: 'Marco',
    lastName: 'Verde',
    phone: '+39 555 123 4567',
    role: 'custom',
    farms: ['project-2', 'project-5'],
    customPermissions: {
      pages: ['dashboard', 'map', 'stations', 'analytics'],
      analyticsPermissions: {
        downloadData: true,
      },
      reportsPermissions: {
        viewReports: false,
        downloadDocuments: false,
      },
    },
    isActive: false,
    emailVerified: true,
    lastLogin: new Date(Date.now() - 7 * 24 * 3600000),
    createdAt: new Date('2023-06-12T12:15:00Z'),
  },
  {
    id: '5',
    email: 'luca.bianchi@agrilink.dev',
    firstName: 'Luca',
    lastName: 'Bianchi',
    phone: '+39 234 567 8901',
    role: 'admin',
    farms: ALL_PROJECTS,
    isActive: true,
    emailVerified: true,
    lastLogin: new Date(Date.now() - 5 * 3600000),
    createdAt: new Date('2023-02-10T11:45:00Z'),
  },
  {
    id: '6',
    email: 'sophia.ferrari@agrilink.dev',
    firstName: 'Sophia',
    lastName: 'Ferrari',
    phone: '+39 345 678 9012',
    role: 'reviewer',
    farms: ['project-2', 'project-5'],
    isActive: true,
    emailVerified: true,
    lastLogin: new Date(Date.now() - 15 * 60000),
    createdAt: new Date('2023-04-05T09:20:00Z'),
  },
  {
    id: '7',
    email: 'alessandro.romano@agrilink.dev',
    firstName: 'Alessandro',
    lastName: 'Romano',
    phone: '+39 456 111 0123',
    role: 'viewer',
    farms: ['project-1'],
    isActive: true,
    emailVerified: true,
    lastLogin: new Date(Date.now() - 45 * 60000),
    createdAt: new Date('2023-06-18T14:00:00Z'),
  },
  {
    id: '8',
    email: 'francesca.russo@agrilink.dev',
    firstName: 'Francesca',
    lastName: 'Russo',
    phone: '+39 567 890 1234',
    role: 'admin',
    farms: ALL_PROJECTS,
    isActive: true,
    emailVerified: true,
    lastLogin: new Date(Date.now() - 3 * 3600000),
    createdAt: new Date('2023-03-15T16:10:00Z'),
  },
  {
    id: '9',
    email: 'giovanni.colombo@agrilink.dev',
    firstName: 'Giovanni',
    lastName: 'Colombo',
    phone: '+39 678 901 2345',
    role: 'reviewer',
    farms: ['project-1', 'project-2'],
    isActive: true,
    emailVerified: true,
    lastLogin: new Date(Date.now() - 90 * 60000),
    createdAt: new Date('2023-07-22T07:55:00Z'),
  },
];

export const MOCK_STATS = {
  totalUsers: MOCK_USERS.length,
  activeUsers: MOCK_USERS.filter((user) => user.isActive).length,
  adminUsers: MOCK_USERS.filter((user) => user.role === 'admin' || user.role === 'superadmin').length,
  reviewerUsers: MOCK_USERS.filter((user) => user.role === 'reviewer').length,
  viewerUsers: MOCK_USERS.filter((user) => user.role === 'viewer').length,
};
